import { IFrameEmbedSliceData } from '@adapters/prismic/types/slices';
import styles from './IFrameEmbed.module.scss';

const IFrameEmbed = ({ url, title, width, height }: IFrameEmbedSliceData) => (
  <div
    data-testid="data-iframe-embed-container"
    className={styles.iframeEmbedContainer}
  >
    <iframe
      data-testid="data-iframe-embed"
      src={url}
      title={title}
      width={width ? `${width}px` : '100%'}
      height={height ? `${height}px` : '100%'}
      scrolling="yes"
    />
  </div>
);

export default IFrameEmbed;
